/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Window_Resize_BlInputs */

const en_window_resize_bl = /** @type {(inputs: Window_Resize_BlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resize from bottom-left`)
};

const ar_window_resize_bl = /** @type {(inputs: Window_Resize_BlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيير الحجم من الزاوية السفلية اليسرى`)
};

const bn_window_resize_bl = /** @type {(inputs: Window_Resize_BlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিচ-বাম থেকে রিসাইজ করুন`)
};

const de_window_resize_bl = /** @type {(inputs: Window_Resize_BlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe von unten links ändern`)
};

const es_window_resize_bl = /** @type {(inputs: Window_Resize_BlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar tamaño desde abajo a la izquierda`)
};

const fr_window_resize_bl = /** @type {(inputs: Window_Resize_BlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionner à partir du coin inférieur gauche`)
};

const pt_window_resize_bl = /** @type {(inputs: Window_Resize_BlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionar do canto inferior esquerdo`)
};

const zh_window_resize_bl = /** @type {(inputs: Window_Resize_BlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从左下角调整大小`)
};

const tr_window_resize_bl = /** @type {(inputs: Window_Resize_BlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sol alttan yeniden boyutlandır`)
};

const ru_window_resize_bl = /** @type {(inputs: Window_Resize_BlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение размера слева внизу`)
};

const pl_window_resize_bl = /** @type {(inputs: Window_Resize_BlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmień rozmiar od lewego dolnego rogu`)
};

/**
* | output |
* | --- |
* | "Resize from bottom-left" |
*
* @param {Window_Resize_BlInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const window_resize_bl = /** @type {((inputs?: Window_Resize_BlInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Window_Resize_BlInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_window_resize_bl(inputs)
	if (locale === "bn") return bn_window_resize_bl(inputs)
	if (locale === "de") return de_window_resize_bl(inputs)
	if (locale === "es") return es_window_resize_bl(inputs)
	if (locale === "fr") return fr_window_resize_bl(inputs)
	if (locale === "pt") return pt_window_resize_bl(inputs)
	if (locale === "zh") return zh_window_resize_bl(inputs)
	if (locale === "tr") return tr_window_resize_bl(inputs)
	if (locale === "ru") return ru_window_resize_bl(inputs)
	if (locale === "pl") return pl_window_resize_bl(inputs)
	return en_window_resize_bl(inputs)
});